export default __webpack_public_path__ + "static/confused-pup.71c4bd14c8055296c6aa9c06ee57bcde.svg";